import apiClient from './client'
import axios from 'axios'

export type PostEntityType = 'device' | 'device_instance'

export interface PostAttachment {
  id: number
  post_id: number
  original_filename: string
  file_size: number
  mime_type?: string
  created_at?: string
}

export interface PostItem {
  id: number
  entity_type: PostEntityType
  entity_id: number
  content: string
  created_at: string
  updated_at: string
  attachments: PostAttachment[]
}

export const getPosts = async (entityType: PostEntityType, entityId: number): Promise<PostItem[]> => {
  const response = await apiClient.get('/api/posts', {
    params: {
      entity_type: entityType,
      entity_id: entityId,
    },
  })
  return Array.isArray(response.data) ? response.data : []
}

export const createPost = async (entityType: PostEntityType, entityId: number, content: string): Promise<{ id: number }> => {
  const response = await apiClient.post('/api/posts', {
    entity_type: entityType,
    entity_id: entityId,
    content,
  })
  return response.data
}

export const updatePost = async (postId: number, content: string): Promise<void> => {
  await apiClient.put(`/api/posts/${postId}`, { content })
}

export const deletePost = async (postId: number): Promise<void> => {
  await apiClient.delete(`/api/posts/${postId}`)
}

export const uploadPostAttachments = async (postId: number, files: File[]): Promise<PostAttachment[]> => {
  const formData = new FormData()
  files.forEach((file) => {
    formData.append('files', file)
  })

  const runtimeBaseUrl = typeof window !== 'undefined' ? window.location.origin : ''
  const cleanAxios = axios.create({
    baseURL: runtimeBaseUrl,
    timeout: 10 * 60 * 1000,
  })
  try {
    const response = await cleanAxios.post(`/api/posts/${postId}/attachments`, formData)

    if (response.data && typeof response.data === 'object' && 'success' in response.data && response.data.success) {
      return Array.isArray(response.data.data) ? response.data.data : []
    }
    if (response.data && typeof response.data === 'object' && 'error' in response.data) {
      throw new Error(String(response.data.error))
    }
    return Array.isArray(response.data) ? response.data : []
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const serverData = error.response?.data as { error?: string; details?: unknown } | undefined
      if (serverData?.error) {
        const details = serverData.details ? ` (${JSON.stringify(serverData.details)})` : ''
        throw new Error(`${serverData.error}${details}`)
      }
    }
    throw error
  }
}

export const getAttachmentViewUrl = (attachmentId: number): string => `/api/attachments/${attachmentId}?mode=view`
export const getAttachmentDownloadUrl = (attachmentId: number): string => `/api/attachments/${attachmentId}?mode=download`
